export default class Modals {
  constructor() {
    this.triggers = document.querySelectorAll('[data-modal]')
    this.activeModals = []
    this.iframes = new Map()

    if (!this.triggers) return

    this.initHandlers()
    this.initTriggers()
  }

  hasBlockingModal() {
    return this.activeModals.some(
      (modal) => !modal.hasAttribute('data-non-blocking'),
    )
  }

  initHandlers() {
    const close = (e) => {
      const valid =
        e.key == 'Escape' ||
        e.target.closest('.is-exit') ||
        e.target.classList.contains('modal-background')

      if (valid && this.activeModals.length > 0) {
        // Get the topmost (most recently opened) modal
        const currentModal = this.activeModals[this.activeModals.length - 1]

        // Persistent modals (e.g. cookie consent while no choice has been made)
        // require an explicit action: Esc and backdrop clicks are ignored, only
        // an .is-exit control can close them.
        if (
          currentModal.hasAttribute('data-persistent') &&
          !e.target.closest('.is-exit')
        ) {
          return
        }

        // Remove the modal from active state
        currentModal.classList.remove('is-active')
        currentModal.removeEventListener('click', this.closeHandler)

        // Remove from active modals array
        this.activeModals.pop()

        // Handle iframe cleanup
        const iframe = this.iframes.get(currentModal)
        if (iframe) {
          iframe.src = ''
          this.iframes.delete(currentModal)
        }

        this.setClipped(this.hasBlockingModal())

        if (this.activeModals.length === 0)
          document.removeEventListener('keyup', this.closeHandler)
      }
    }

    this.closeHandler = close.bind(this)
  }

  /**
   * Stop the page scrolling under a blocking modal. Clipping the page alone
   * (is-clipped) sends mobile browsers back to its top, so the body is also
   * held where it was, and the page scrolled back there once unclipped.
   */
  setClipped(clipped) {
    const html = document.documentElement
    const body = document.body
    if (clipped === html.classList.contains('is-clipped')) return

    if (clipped) {
      this.clippedScrollY = window.scrollY
      body.style.top = `-${this.clippedScrollY}px`
      body.classList.add('is-scroll-locked')
      html.classList.add('is-clipped')
    } else {
      html.classList.remove('is-clipped')
      body.classList.remove('is-scroll-locked')
      body.style.top = ''
      window.scrollTo({ top: this.clippedScrollY || 0, behavior: 'instant' })
    }
  }

  /**
   * Open a modal element. Exposed so modals that aren't triggered by a click
   * (e.g. the cookie consent modal on page load) can be opened from JS.
   */
  open(modal) {
    if (!modal || this.activeModals.includes(modal)) return

    // Add to active modals stack
    this.activeModals.push(modal)

    // Add keyup listener once while there is at least one active modal.
    if (this.activeModals.length === 1) {
      document.addEventListener('keyup', this.closeHandler)
    }

    this.setClipped(this.hasBlockingModal())

    modal.classList.add('is-active')
    modal.addEventListener('click', this.closeHandler)

    // Skip hidden inputs (e.g. checkboxes inside a collapsed section) so
    // opening a modal never scrolls to something the user can't see.
    const inputElement = modal.querySelector('input')
    if (inputElement && inputElement.offsetParent !== null) inputElement.focus()

    const iframe = modal.querySelector('iframe')
    if (iframe) {
      iframe.src = iframe.dataset.src
      this.iframes.set(modal, iframe)
    }
  }

  openById(id) {
    this.open(document.querySelector(`.modal[data-id="${id}"]`))
  }

  initTriggers() {
    this.triggers.forEach((e) => {
      e.addEventListener('click', () => {
        this.open(
          document.querySelector('.modal[data-id=' + e.dataset.modal + ']'),
        )
      })
    })
  }
}
